// CSS variables, so the same object serves light and dark mode
// (src/themes/ThemePrefs.tsx sets the values).
export const lightTheme = {
    background : 'var(--app-bg)',
    nav: {
      background: "var(--app-surface)"
    },
    primary: 'var(--brand)',
    text: {
      primary : "var(--app-muted)",
      bold: "var(--app-text)",
      title: "var(--app-heading)"
    },
  }

export const darkTheme = {
    background : '#333',
    nav: {
      background: "#1e1e2d"
    },
    primary: 'var(--brand)',
    text: {
      primary : "#fff",
      bold: "white",
      title: "#ffff",
    },
  }
  
 
  
  export const partyTheme = {
    backgroundColor: "#eeff00",
    textColor: "#ff88cc",
    primary: "#aa00ee"
  }